// @TODO: Move in editors.

import {initial, isEmpty, isString, last} from 'lodash';

import {isRegexPart, StringOrTemplate, StringTemplatePart} from '../editors/commons/stringTemplateModel';
import {getLabelForRegex} from '../editors/expressions/expressionLabels';
import {ExpressionRef} from '../editors/expressions/expressionRefModel';

export function normalizeStringTemplate(template: StringTemplatePart[]): StringOrTemplate {
  const trimmed = templateTrim(template);

  if (trimmed.length === 0) {
    return '';
  }

  if (trimmed.length === 1 && isString(trimmed[0])) {
    return trimmed[0];
  }

  return {template: trimmed};
}

function templateTrim(template: StringTemplatePart[]): StringTemplatePart[] {
  return templateTrimRight(templateTrimLeft(template));
}

function templateTrimLeft(template: StringTemplatePart[]): StringTemplatePart[] {
  const [head, ...rest] = template;

  if (isEmpty(template) || !isString(head)) {
    return template;
  }

  const trimmedHead = head.trimLeft();

  if (trimmedHead) {
    return [trimmedHead, ...rest];
  }

  return templateTrimLeft(rest);
}

function templateTrimRight(template: StringTemplatePart[]): StringTemplatePart[] {
  const rest = initial(template);
  const tail = last(template);

  if (isEmpty(template) || !isString(tail)) {
    return template;
  }

  const trimmedTail = tail.trimRight();

  if (trimmedTail) {
    return [...rest, trimmedTail];
  }

  return templateTrimRight(rest);
}

export function nullInterpolator(template: StringOrTemplate) {
  if (isString(template)) {
    return template;
  }

  return template.template
    .map((part) => {
      if (isString(part)) {
        return part;
      }

      if (isRegexPart(part)) {
        return getLabelForRegex(part);
      }

      return '';
    })
    .join('');
}

export function nullUrlInterpolator(template: StringOrTemplate) {
  try {
    const url = new URL(nullInterpolator(template));
    return url;
  } catch (err) {
    return undefined;
  }
}

export function appendExpressionRef(input: StringOrTemplate | undefined | null, ref: ExpressionRef) {
  if (!input) {
    return {template: [ref]};
  }

  if (isString(input)) {
    return {template: [input, ref]};
  }

  return {template: [...input.template, ref]};
}
